import { render } from "./Pasarelas.vue?vue&type=template&id=17e6e803&scoped=true"
import script from "./Pasarelas.vue?vue&type=script&lang=js"
export * from "./Pasarelas.vue?vue&type=script&lang=js"

import "./Pasarelas.vue?vue&type=style&index=0&id=17e6e803&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e6e803"]])

export default __exports__